module.exports = __webpack_public_path__ + "img/FaceOutlined.a77a2ff8.svg";